var map = {
	"./facebook-icon.svg": "03ba",
	"./feather-icons.svg": "3d2d",
	"./instagram-icon.svg": "11db",
	"./medium-icon.svg": "db34",
	"./vicons.svg": "321f",
	"./whatsapp-icon.svg": "1f60"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";